import React from "react";

export interface DirtyWarningInputProps {
    disableDirtyTracking?: boolean;
}

export interface DirtyWarningConfirmProps {
    showDirtyWarning?: boolean;
    dirtyWarningMessage?: string;
    resetDirtyTracking?: boolean;
}

export type DirtyWarningContextShape = {
    dirty: boolean,    
    setDirty: (value: boolean) => void,    
    confirm: (message?: string) => Promise<boolean>;
}

export const DirtyWarningContext = React.createContext<DirtyWarningContextShape>({
    dirty: false,        
    setDirty: () => {},    
    confirm: () => { return new Promise<boolean>((resolve) => {resolve(false)}); }
});

export const DirtyWarningConsumer = DirtyWarningContext.Consumer;

export const useDirtyWarningContext = () => {
    return React.useContext(DirtyWarningContext);    
}